function waitForMenu() {
  const menu = document.querySelector('.mega-menu__content');
  
  if (menu) {
    // Menu found - remove display none
    menu.style.display = '';
    // Or set specific display value
    // menu.style.display = 'block';
    console.log('Menu loaded and displayed');
  } else {
    // Menu not found yet - check again after a short delay
    setTimeout(waitForMenu, 50); // Check every 50ms
  }
}

function initBlinkUnderscore() {
  const run = () => {
    if (!window.gsap) return false;

    const els = document.querySelectorAll('[data-blink-underscore]');
    els.forEach((el) => {
      if (el.dataset.blinkInitialized === 'true') return;
      el.dataset.blinkInitialized = 'true';

      window.gsap.to(el, {
        opacity: 0,
        duration: 0.6,
        repeat: -1,
        yoyo: true,
        ease: 'steps(1)',
      });
    });

    return true;
  };

  if (!run()) {
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (run() || tries > 40) clearInterval(timer);
    }, 100);
  }
}

// Start checking when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  waitForMenu();
  initBlinkUnderscore();
});